import React, { Component } from 'react'
import Radium from 'radium'
import Navbar from '../components/navbar'
import MobileContent from '../components/mobile-content'
import { FORM_STYLES } from '../components/assets/forms-shared'
import { BTN_STYLES } from '../components/assets/btns-shared'
import Palette from '../components/assets/palette'
import { Helmet } from 'react-helmet'
import MobileDetect from 'mobile-detect'
import Scrollspy from 'react-scrollspy'
import Sticky from 'react-stickynode'
import TinasLearnKu from '@haiku/taylor-learnpage/react'

const md = (typeof window !== 'undefined')
  ? new MobileDetect(window.navigator.userAgent)
  : {mobile: () => { return false }}
const isMobile = md.mobile()

const STYLES = {
  featuresNavWrap: {
    width: 320,
    height: '100%',
    marginLeft: 50,
    marginRight: 50,
  },
  featuresContentWrap: {
    width: '70%',
    height: '100%',
    paddingRight: 12,
    '@media screen and (max-width: 1115px)': {
      width: '90%',
      paddingLeft: 10,
      paddingRight: 10
    },
  },
  link: {
    color: Palette.LIGHTEST_BLUE,
    textDecoration: 'none'
  },
  sideNavigationWrap: {
    paddingTop: 35
  },
  sideNavigation: {
    paddingLeft: 0,
    marginTop: 20,
    borderRadius: 8,
    overflow: 'hidden',
    boxShadow: '0 20px 150px 0 rgba(0,0,0,.5)',
    backgroundColor: Palette.COAL
  },
  sideNavigationLink: {
    width: 'auto',
    display: 'block',
    height: '100%',
    padding: '1em 1em 1em 25px',
    textTransform: 'uppercase',
    textDecoration: 'none'
  },
  sideNavigationTitle: {
    backgroundColor: Palette.COAL,
    color: Palette.SUNSTONE,
    paddingTop: 10,
    paddingLeft: 25,
    paddingBottom: 5
  },
  pageSection: {
    paddingTop: 35,
    marginBottom: 50
  },
  contentWrap: {
    maxWidth: 1440,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 80,
    marginBottom: 30
  },
  learnContentWrap: {
    width: '100%',
    height: '100%',
    paddingLeft: 50,
    paddingRight: 50,
    color: Palette.SUNSTONE,
    '@media screen and (max-width: 1115px)': {
      width: '90%',
      paddingLeft: 10,
      paddingRight: 10
    },
  },
  flexGrid: {
    display: 'flex',
    alignContent: 'flex-start',
    flexWrap: 'wrap',
    '@media screen and (max-width: 1115px)': {
      display: 'block'
    }
  },
  flexGridTut: {
    width: '30%',
    borderRadius: 8,
    overflow: 'hidden',
    boxShadow: '0 20px 150px 0 rgba(0,0,0,.5)',
    backgroundColor: Palette.COAL,
    marginTop: 20,
    marginBottom: 40,
    marginRight: '3%',
    '@media screen and (max-width: 1115px)': {
      width: '100%',
      marginTop: 30,
      marginBottom: 90
    }
  },
  flexGridTutSpacer: {
    width: '30%',
    borderRadius: 8,
    overflow: 'hidden',
    marginTop: 20,
    marginBottom: 40,
  },
  flexGridBelow: {
    width: '48%',
    overflow: 'hidden',
    marginTop: 20,
    marginBottom: 40,
    paddingRight: 30,
    '@media screen and (max-width: 1115px)': {
      width: '100%',
      marginTop: 30,
      marginBottom: 90,
      paddingRight: 0
    }
  },
  flexGridContent: {
    padding: '0 20px 20px'
  },
  link: {
    color: '#43C4D1',
    textDecoration: 'none'
  },
  featureImage: {
    backgroundColor: 'rgb(250,250,250)',
    minHeight: 160,
    objectPosition: 'center',
    objectFit: 'cover',
    border: '1px solid #232d30'
  },
  h2: {
    '@media screen and (min-width: 1115px)': {
      fontSize: 38
    }
  },
  h3: {
    color: Palette.SUNSTONE,
    fontSize: 37,
    letterSpacing: .5,
    lineHeight: '40px',
    wordWrap: 'break-word',
    fontFamily: 'brandon-grotesque',
    textTransform: 'uppercase',
    paddingTop: 15,
    margin: '0 0 12px'
  },
  h3Alt: {
    color: Palette.LIGHT_BLUE,
    minHeight: '2em',
    fontSize: 18,
    letterSpacing: .5,
    lineHeight: '22px',
    wordWrap: 'break-word',
    fontFamily: 'brandon-grotesque',
    textTransform: 'uppercase',
    paddingTop: 12,
    margin: 0
  },
  subtitle: {
    color: Palette.ROCK,
    fontSize: 15,
    marginTop: 5,
    fontWeight: 300,
    lineHeight: '22px',
  },
  pageSubtitle: {
    color: Palette.ROCK,
    fontSize: '1.5em',
    marginTop: 5,
    lineHeight: 1.22,
  },
  subsectionTitle: {
    marginTop: 80,
  },
  type: {
    color: Palette.SUNSTONE,
    fontWeight: 600,
    marginTop: 6,
    fontSize: 12,
    textTransform: 'uppercase'
  },
  credit: {
    fontWeight: 600,
    color: Palette.SUNSTONE,
    fontSize: 12,
  },
  dev: {
    border: '2px solid ' + Palette.LIGHT_BLUE,
  },
  sectionWrap: {
    fontSize: 18,
    textAlign: 'left',
    '@media screen and (max-width: 1115px)': {
      textAlign: 'center'
    },
  },
  sectionTitle: {
    marginTop: 60,
    textAlign: 'left',
    '@media screen and (max-width: 1115px)': {
      textAlign: 'center'
    },
    '@media screen and (min-width: 1115px)': {
      fontSize: 38
    }
  },
  centerBtnOnMobile: {
    left: 160,
    '@media screen and (max-width: 1115px)': {
      left: '50%'
    }
  },
  hideOnMobile: {
    '@media screen and (max-width: 700px)': {
      display: 'none'
    }
  },
  hideOnTablet: {
    '@media screen and (max-width: 1115px)': {
      display: 'none'
    }
  },
  kuWrap: {
    width: 'calc(100% - 40px)',
    height: 400,
    marginTop: 40,
    '@media screen and (max-width: 1115px)': {
      width: '100%'
    },
    '@media screen and (max-width: 700px)': {
      height: 200
    }
  },
  ...FORM_STYLES,
  ...BTN_STYLES
}

const SECTIONS = [
  {
    title: "An Overview of Haiku",
    id: "overview",
    boxes: [
      {
        link: "https://www.youtube.com/watch?v=B8iZlkRrwS4",
        img: require("./learn/introducing.jpg"),
        title: "Introducing Haiku",
        format: "Video",
        subtitle: "Create dynamic, cross-platform UIs using design tools, code, or both."
      },
      {
        link: "https://www.youtube.com/watch?v=_rd8XHnk2Cg",
        img: require("./learn/workflow.jpg"),
        title: "Workflow with Haiku",
        format: "Video",
        subtitle: "Design assets with Sketch, animate them with Haiku, and include them in any web app—then keep iterating."
      },
      {
        link: "/blog/motion-design-for-the-web-ios-android-with-haiku",
        img: require("./learn/motion.jpg"),
        title: "Getting started with motion design",
        format: "Blog post",
        subtitle: "Learn the basics of motion design and get started with Haiku.",
      },
      {
        link: "https://www.youtube.com/watch?v=Gs5YG_uf5UQ",
        img: require("./learn/motion-design.jpg"),
        title: "Getting started with animation in Haiku",
        format: "Video",
        subtitle: "Learn the basics of motion design and get started with Haiku."
      },
      {
        link: "/blog/figma-haiku-integration-delivering-motion",
        img: require("./learn/figma-plus-haiku.png"),
        title: "Getting started with Figma & Haiku",
        format: "Blog post",
        subtitle: "How to integrate and use Figma projects in Haiku."
      },
      {
        link: "https://www.youtube.com/watch?v=QFZ9y3XeXxs",
        img: require("./learn/haiku-review.jpg"),
        title: "Haiku.ai Review",
        format: "Video",
        subtitle: "Export Sketch Animations to native iOS & Android Code!",
        author: "By: Maex"
      }
    ]
  },
  {
    title: "Getting started with your drawing tools",
    id: "drawing",
    boxes: [
      {
        link: "https://help.haiku.ai/troubleshooting-and-help/importing-designs-from-sketch",
        img: require("./learn/sketch.jpg"),
        title: "Importing designs from Sketch",
        format: "Help doc",
        subtitle: "How to bring assets designed in Sketch into Haiku and troubleshooting common issues."
      },
      {
        link: "https://help.haiku.ai/troubleshooting-and-help/importing-designs-from-figma",
        img: require("./learn/figma_haiku.jpg"),
        title: "Importing designs from Figma",
        format: "Help doc",
        subtitle: "How to bring assets designed in Figma into Haiku and troubleshooting common issues."
      },
      {
        link: "https://help.haiku.ai/troubleshooting-and-help/importing-designs-from-adobe-illustrator",
        img: require("./learn/ai-haiku.jpg"),
        title: "Importing designs from Adobe Illustrator",
        format: "Help doc",
        subtitle: "How to bring assets designed in Illustrator into Haiku and troubleshooting common issues."
      },
      {
        link: "https://help.haiku.ai/troubleshooting-and-help/importing-svgs-to-haiku",
        img: require("./learn/import-svg.jpg"),
        title: "Importing SVG's to Haiku",
        format: "Help doc",
        subtitle: "What if I don't use Sketch / Figma / Illustrator?"
      }
    ]
  },
  {
    title: "Fundamentals",
    id: "fundamentals",
    boxes: [
      {
        link: "https://help.haiku.ai/fundamentals/haiku-glossary",
        img: require("./learn/glossary.jpg"),
        title: "Haiku Glossary",
        format: "Help doc",
        subtitle: "Understand the terms and naming conventions used in the Haiku app."
      },
      {
        link: "https://help.haiku.ai/troubleshooting-and-help/how-to-start-a-new-project",
        img: require("./learn/new-project.png"),
        title: "How to start a new project",
        format: "Help doc",
        subtitle: "Different ways to create a new Haiku project."
      },
      {
        link: "https://help.haiku.ai/fundamentals/forking-haiku-projects",
        img: require("./learn/fork-project.jpg"),
        title: "Forking Haiku Projects",
        format: "Help doc",
        subtitle: "Forks are a unique copy of a project, which doesn't affect the original project. "
      },
      {
        link: "https://help.haiku.ai/fundamentals/public-vs-private-projects",
        img: require("./learn/public-private.jpg"),
        title: "Public vs private projects",
        format: "Help doc",
        subtitle: "When you create a Haiku project, you can decide if you want it to be public or private."
      },
      {
        link: "https://help.haiku.ai/fundamentals/add-a-keyframe",
        img: require("./learn/create-keyframe.jpg"),
        title: "Add a keyframe",
        format: "Help doc",
        subtitle: "You can add keyframes to the timeline in three ways."
      },
      {
        link: "https://help.haiku.ai/fundamentals/adding-transitions",
        img: require("./learn/create-tween.jpg"),
        title: "Adding transitions",
        format: "Help doc",
        subtitle: "In the animation world, transitions are known as tweens."
      },
      {
        link: "https://help.haiku.ai/troubleshooting-and-help/selecting-slices-in-haiku",
        img: require("./learn/select-slices.jpg"),
        title: "Selecting slices in Haiku",
        format: "Help doc",
        subtitle: "How can I select an object in the canvas?"
      },
      {
        link: "https://www.youtube.com/watch?v=as_ogKd-Lbg",
        img: require("./learn/ungroup.jpg"),
        title: "Group/Ungroup in Haiku",
        format: "Video",
        subtitle: "Maintain the original position of your slices with Ungroup."
      },
      {
        link: "https://help.haiku.ai/troubleshooting-and-help/align-slices",
        img: require("./learn/align.jpg"),
        title: "Align slices",
        format: "Help doc",
        subtitle: "How can I align elements in Haiku?"
      },
      {
        link: "https://help.haiku.ai/troubleshooting-and-help/reorganizing-layers-in-haiku",
        img: require("./learn/organize-slices.jpg"),
        title: "Reorganizing layers in Haiku",
        format: "Help doc",
        subtitle: "How can I change the order of my layers / slices / elements / shapes?"
      },
      {
        link: "https://help.haiku.ai/fundamentals/zooming-in-and-out",
        img: require("./learn/zoom.jpg"),
        title: "Zooming in and out",
        format: "Help doc",
        subtitle: "You have a couple of options to Zoom in and out of both the timeline and the stage."
      },
      {
        link: "https://help.haiku.ai/troubleshooting-and-help/setting-the-origin-point-on-elements",
        img: require("./learn/origin-point.jpg"),
        title: "Setting the origin point on elements",
        format: "Help doc",
        subtitle: "How can I change the origin point for scaling or rotating an element?"
      },
      {
        link: "https://www.youtube.com/watch?v=sPY9MpicN5o",
        img: require("./learn/origin-2.jpg"),
        title: "Haiku: Changing origin (point of rotation)",
        format: "Video",
        subtitle: "A quick tutorial on how to change the point of rotation (origin) in Haiku."
      },
      {
        link: "https://help.haiku.ai/troubleshooting-and-help/stage-sizing",
        img: require("./learn/stage-sizing.png"),
        title: "Stage sizing",
        format: "Help doc",
        subtitle: "How can I adjust the size of the stage in Haiku?"
      },
      {
        link: "https://help.haiku.ai/troubleshooting-and-help/frames-and-miliseconds",
        img: require("./learn/frames.png"),
        title: "Frames and miliseconds",
        format: "Help doc",
        subtitle: "Can I switch from frames to milliseconds in the timeline?"
      },
      {
        link: "https://help.haiku.ai/troubleshooting-and-help/rotating-slices-in-haiku",
        img: require("./learn/rotate-slices.jpg"),
        title: "Rotating slices in Haiku",
        format: "Help doc",
        subtitle: "How can I rotate my slice / element?"
      },
      {
        link: "https://help.haiku.ai/troubleshooting-and-help/using-consistent-transform-sizes-on-elements-of-varying-size",
        img: require("./learn/varying-size.jpg"),
        title: "Using consistent transform sizes on elements of varying size.",
        format: "Help doc",
        subtitle: "Work with different sized elements easier."
      },
      {
        link: "https://help.haiku.ai/troubleshooting-and-help/changing-colors-in-haiku",
        img: require("./learn/change-color.jpg"),
        title: "Changing colors in Haiku",
        format: "Help doc",
        subtitle: "Can I change the stage's background color or an asset's color?"
      },
      {
        link: "https://help.haiku.ai/fundamentals/animating-the-stroke-property-in-haiku",
        img: require("./learn/add-stroke.jpg"),
        title: "Animating the stroke property in Haiku",
        format: "Help doc",
        subtitle: "Steps to add the stroke property to an element."
      },
      {
        link: "https://www.youtube.com/watch?v=fHisNZ-j7cc",
        img: require("./learn/components.jpg"),
        title: "Haiku: Intro to Sub-components",
        format: "Video",
        subtitle: "A quick tutorial on using sub-components within Haiku."
      },
      {
        link: "https://help.haiku.ai/fundamentals/subcomponent-playback",
        img: require("./learn/component-playback.jpg"),
        title: "Subcomponent playback",
        format: "Help doc",
        subtitle: "Find the “playback” property on the timeline where you instantiated the component."
      },
      {
        link: "https://help.haiku.ai/fundamentals/component-preview",
        img: require("./learn/component-preview.png"),
        title: "Component preview",
        format: "Help doc",
        subtitle: "How to preview each component individually and all components together."
      },
      {
      link: "/blog/understanding-states/",
      img: require("./learn/understanding-states.jpg"),
      title: "Understanding States step by step",
      format: "Blog post",
      subtitle: "Learn how to create, edit, use and make the most out of States in Haiku."
      },
      {
        link: "https://help.haiku.ai/fundamentals/how-to-use-the-haiku-code-editor",
        img: require("./learn/code-editor.jpg"),
        title: "How to use the Haiku Code editor",
        format: "Help doc",
        subtitle: "How to use the built-in Code Editor or any custom editor."
      }
    ]
  },
  {
    title: "Creating animations",
    id: "animation",
    boxes: [
      {
        link: "/blog/curved-paths",
        img: require("./learn/curved-paths.jpg"),
        title: "Animating elements along curved paths",
        format: "Blog post",
        subtitle: "Vertical curved path with flow effect."
      },
      {
        link: "https://www.youtube.com/watch?v=NhveVVgR_5Q",
        img: require("./learn/curved-paths2.jpg"),
        title: "Haiku Tutorial: Animating Elements Along Curved Paths",
        format: "Video",
        subtitle: "Horizontal curved path with bounce effect."
      },
      {
        link: "https://www.youtube.com/watch?v=WBZU0E5Z5hA",
        img: require("./learn/record-player.jpg"),
        title: "Animating a record player",
        format: "Video",
        subtitle: "Haiku Tour/walkthrough + Spinning the record.",
        author: "By: Anjan Shrestha"
      },
      {
        link: "https://www.youtube.com/watch?v=_KcEKtj6E4s",
        img: require("./learn/menu-transition.jpg"),
        title: "Menu overlay transition Timelapse",
        format: "Video",
        subtitle: "Quick tutorial to animate a menu transition.",
        author: "By: Anjan Shrestha"
      },
      {
        link: "https://www.youtube.com/watch?v=ejypmuzNgyE",
        img: require("./learn/animate-present.jpg"),
        title: "Animating a Present with Haiku - Timelapse",
        format: "Video",
        subtitle: "Using Haiku, you can fine-tune vector animations and then drop them into any web app with a line of code."
      },
      {
        link: "https://help.haiku.ai/troubleshooting-and-help/motion-blur-in-haiku",
        img: require("./learn/motion-blur.jpg"),
        title: "Motion blur in Haiku",
        format: "Help doc",
        subtitle: "Can Haiku do motion blurs?"
      },
      {
        link: "/blog/morphing-intro",
        img: require("./learn/pm_0.jpg"),
        title: "Introduction to Path Morphing",
        format: "Blog post",
        subtitle: "Learn how to path morph using Haiku."
      },
      {
        link: "https://www.youtube.com/watch?v=V9lVf6qcQZ4",
        img: require("./learn/morph_advanced.jpg"),
        title: "Advanced path morphing",
        format: "Video",
        subtitle: "Advanced follow-along tutorial on path morphing."
      }
    ]
  },
  {
    title: "Adding interactivity",
    id: "interactivity",
    boxes: [
      {
        link: "/blog/understanding-actions/",
        img: require("./learn/understanding-actions.jpg"),
        title: "Understanding Actions",
        format: "Blog post and Video",
        subtitle: "Understand the two different types of Actions available in Haiku, Frame and Element Actions."
      },
      {
        link: "/blog/designing-the-real-thing-with-haiku-actions/",
        img: require("./learn/motion-ship.jpg"),
        title: "DESIGNING THE REAL THING WITH HAIKU ACTIONS",
        format: "Blog post",
        subtitle: "Actions are small snippets of code (JavaScript) with a lot of power. "
      },
      {
        link: "https://www.youtube.com/watch?v=S376xLw7RUE",
        img: require("./learn/solar-actions.jpg"),
        title: "Getting started with interactivity in Haiku",
        format: "Video",
        subtitle: "Learn how to add interactivity to your designs for the Web using Actions, States & Expressions in Haiku."
      },
      {
        link: "https://www.youtube.com/watch?v=8BEO3Lb_Qdg",
        img: require("./learn/stop-play.jpg"),
        title: "Stop and play button interaction",
        format: "Video",
        subtitle: "Using states and events to create the stop/play interactions of a media player.",
        author: "By: Anjan Shrestha"
      },
      {
        link: "https://www.youtube.com/watch?v=Xb3g8T0JLuY",
        img: require("./learn/tog-tog.jpg"),
        title: "How to make a toggle component",
        format: "Video",
        subtitle: "Quick tutorial on how to make a simple toggle component using Haiku."
      },
      {
        link: "/blog/mimicking-the-medium-clap/",
        img: require("./learn/celebrate.jpg"),
        title: "MIMICKING THE MEDIUM CLAP ANIMATION WITH SKETCH AND HAIKU",
        format: "Blog post",
        subtitle: "Export to React, after designing in Sketch, and tweaking keyframes in Haiku.",
        author: "By: Kyle Gill"
      },
      {
        link: "https://www.youtube.com/watch?v=vFxsDarkAVk",
        img: require("./learn/dynamic-instances.jpg"),
        title: "Creating dynamic instances of an element",
        format: "Video",
        subtitle: "Using states and actions to create instances of an element depending on where the user clicks."
      },
      {
        link: "https://www.youtube.com/watch?v=oKvDywEVynI",
        img: require("./learn/sendit.png"),
        title: "Communicating between components",
        format: "Video",
        subtitle: "Learn how to use the send() api to communicate between components."
      },
      {
        link: "/blog/from-figma-to-react/",
        img: require("./learn/figma-react.jpg"),
        title: "From Figma to React with Haiku",
        format: "Blog post",
        subtitle: "Bring your Figma designs to life by easily animating and publishing as React components. "
      }
    ]
  },
  {
    title: "Using Code",
    id: "code",
    boxes: [
      {
        link: "/blog/helper-functions/",
        img: require("./learn/haiku-code-mode.png"),
        title: "Reusing logic with Helpers",
        format: "Blog post",
        subtitle: "Helpers allow you to define a function that can be later used in an Expression or an Action."
      },
      {
        link: "/blog/accessing-summonables-from-actions/",
        img: require("./learn/accessing-summonables.png"),
        title: "Accessing Summonables from Actions",
        format: "Blog post",
        subtitle: "Summonables are a collection of built-in pieces of dynamic data that you can summon."
      },
      {
        link: "/blog/handling-mouse-and-touch/",
        img: require("./learn/rotating-cube.jpg"),
        title: "Handling mouse and touch in Haiku",
        format: "Blog post",
        subtitle: "This will allow you to create pieces of UI that react to both touch and mouse interactions. "
      },
      {
        link: "/blog/progress-bar/",
        img: require("./learn/embedding_and_publishing.jpg"),
        title: "Progress Bar Tutorial",
        format: "Docs",
        subtitle: "Embed a component in a web app, binding it with application logic."
      }
    ]
  }
];


class Learn extends Component {
  render() {
    return (
    <div>
      <style>
        {`
          .isCurrent {
            background-color: ${Palette.FATHER_COAL};
            color: ${Palette.SUNSTONE}
          }
        `}
      </style>

      <Helmet>
        <title>Tutorials, documentation and help | Haiku</title>
        <meta name="description" content="Learn Haiku with these tutorials - get up and running and learn advanced techniques, dig into documentation and get help." />
        <meta property="og:title" content="Tutorials, documentation and help | Haiku" />
        <meta property="og:description" content="Learn Haiku with these tutorials - get up and running and learn advanced techniques, dig into documentation and get help." />
      </Helmet>

      <Navbar location="learn" />

      <div style={{
        margin: '0 auto',
        width: '100%',
        maxWidth: 1440
      }}>
          <div id="stickyTarget">
            <div style={STYLES.contentWrap}>
              <div style={[STYLES.featuresNavWrap, STYLES.hideOnTablet]}>
                <Sticky bottomBoundary='#stickyTarget'>
                  <div style={STYLES.sideNavigationWrap}>
                    <Scrollspy style={STYLES.sideNavigation} items={['overview', 'drawing', 'fundamentals', 'animation', 'interactivity', 'code']} currentClassName="isCurrent">
                     <a style={STYLES.sideNavigationLink} href="#overview">An Overview</a>
                     <a style={STYLES.sideNavigationLink} href="#drawing">Drawing Tools</a>
                     <a style={STYLES.sideNavigationLink} href="#fundamentals">Fundamentals</a>
                     <a style={STYLES.sideNavigationLink} href="#animation">Animation</a>
                     <a style={STYLES.sideNavigationLink} href="#interactivity">Interactivity</a>
                     <a style={STYLES.sideNavigationLink} href="#code">Using code</a>
                    </Scrollspy>
                  </div>
                </Sticky>
              </div>
              <div style={STYLES.featuresContentWrap}>
                <div style={STYLES.kuWrap}><TinasLearnKu loop={true} sizing="contain" contextMenu="disabled" /></div>
                {
                  SECTIONS.map((section) => {
                    return (
                      <section id={section.id} key={section.id} ref={(el) => section.id = el} style={STYLES.pageSection}>
                        <h3 style={STYLES.h3}>{section.title}</h3>

                        <div style={STYLES.flexGrid}>
                          {
                            section.boxes.map((box) => {
                              return (
                                <div style={STYLES.flexGridTut} key={box.title}>
                                  <a target="_blank" href={box.link}>
                                    <img style={STYLES.featureImage} src={box.img} alt={box.title} />
                                    <div style={STYLES.flexGridContent}>
                                      <h3 style={STYLES.h3Alt}>{box.title}</h3>
                                      <p style={STYLES.type}>{box.format}</p>
                                      <p style={STYLES.subtitle}>{box.subtitle}</p>
                                      <p style={STYLES.credit}>{box.author}</p>
                                    </div>
                                  </a>
                                </div>
                              )
                            })
                          }
                        </div>
                      </section>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
        <div style={[STYLES.contentWrap, STYLES.learnContentWrap]}>
          <div style={STYLES.flexGrid}>
            <div style={STYLES.flexGridBelow}>
              <h2 style={STYLES.sectionTitle}>DOCS</h2>
              <div style={STYLES.sectionWrap}>
                <p>Reference and technical documentation on Haiku for Mac and Haiku Core API's.</p>
                <a href="https://docs.haiku.ai/">
                  <div key='cta7' style={[
                    STYLES.centerBtnOnMobile,
                    STYLES.btn,
                    STYLES.cta,
                    { textAlign: 'center', width: 220, marginTop: 20, display: 'inline-block' },
                    isMobile ? { padding: '14px 24px 13px', width: 'inherit' } : undefined
                  ]}>
                    View Docs
                      </div>
                </a>
              </div>
            </div>
            <div style={STYLES.flexGridBelow}>
              <h2 style={STYLES.sectionTitle}>HELP</h2>
              <div style={STYLES.sectionWrap}>
                <p>Advice and answers on common issues, frequently asked questions, and tips and tricks.</p>
                <a href="https://help.haiku.ai">
                  <div key='cta8' style={[
                    STYLES.centerBtnOnMobile,
                    STYLES.btn,
                    STYLES.cta,
                    { textAlign: 'center', width: 220, marginTop: 20, display: 'inline-block' },
                    isMobile ? { padding: '14px 24px 13px', width: 'inherit' } : undefined
                  ]}>
                    View Help
                      </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <MobileContent />
      </div>
    )
  }

}

export default Radium(Learn)



// WEBPACK FOOTER //
// ./src/pages/learn.js